import React from "react";
import { DatasetInfo as DatasetInfoModel } from "api/model/dataset/DatasetInfo";
import GridRow from "./GridRow";
import { Tags } from "./Tags";

interface DatasetInfoProps {
  dataToUse: DatasetInfoModel;
  isSuccess?: boolean;
  isLoading?: boolean;
  isFetching?: boolean;
  idNumber?: number;
}

const SingleDatasetInfo = ({
  dataToUse,
  isLoading,
  isFetching,
  isSuccess,
  idNumber,
}: DatasetInfoProps) => {
  if (isLoading || isFetching) {
    return <p className="font-semibold text-sm mt-2">searching...</p>;
  }

  if ((!isSuccess && idNumber !== undefined) || dataToUse?.identifier === null) {
    return <p className="font-semibold text-red-500 text-sm mt-2">not found</p>;
  }

  if (dataToUse?.identifier != null) {
    return (
      <div className="mr-4 mt-4 border-1 border-round-md p-4 border-300">
        <GridRow name="ID" value={dataToUse?.identifier} />
        <GridRow name="Title" value={dataToUse?.title} style={{ fontWeight: "semibold" }} />
        <GridRow name="Unit" value={dataToUse?.unit} />
        <GridRow name="Data Type" value={dataToUse?.dataType} />
        <GridRow name="Data Access Type" value={dataToUse?.accessType} />
        <GridRow name="Decimal places" value={dataToUse?.decimalPlaces} />
        <GridRow name="Group id" value={dataToUse?.groupId} />
        <GridRow name="Group title" value={dataToUse?.groupTitle} />
        <GridRow name="Category id" value={dataToUse?.categoryId} />
        <GridRow name="Category title" value={dataToUse?.categoryTitle} />
        <GridRow name="Dataset class" value={dataToUse?.datasetClass} />
        <Tags name="Tags" tags={dataToUse?.tags} />
      </div>
    );
  }

  return null;
};

export default SingleDatasetInfo;
